// Keep in sync with app/lib/enums/data_source_run_status.py
const DataSourceRunStatus = {
  SUCCESS: 'success',
  FAILED: 'failed',
  RUNNING: 'running',
};

export default DataSourceRunStatus;
